// show different message when heavy item(s) exist in smart cart(rebuy)
(function HasHeavyItemsInCart(){
    class HasHeavyItemsInCartManager{
        constructor(){
            this.hasHeavyLI = false
            this.originalMessage = null
            this.init()
        }

        init() {
            if (typeof window.Rebuy !== 'undefined') {
                this.setupEventListeners();
            } else {
                document.addEventListener('rebuy:cart.ready', () => {
                    this.setupEventListeners();
                });
            }
        }

        setupEventListeners() {
            document.addEventListener('rebuy:cart.change', (event) => {
                this.checkHeavyItems(event);
            });

            // Initial check when cart is ready
            this.checkHeavyItems();
        }

        checkHeavyItems(event) {
            const Cart = event?.detail?.cart || window.Rebuy.Cart;
            const prodArray = Cart?.getItems();
            if(!prodArray) return;

            setTimeout(() => {
                const hasHeavyItem = prodArray.some(item => item.product?.tags.includes("heavy"));
                this.hasHeavyLI = hasHeavyItem;

                if(!window.Rebuy?.SmartCart?.dom?.cart) return;
                // Update UI based on heavy items
                this.updateCartMessage(hasHeavyItem);
            }, 500);
        }

        updateCartMessage(hasHeavyItem) {
            const rebuyCart = window.Rebuy.SmartCart.dom.cart;
            if (!rebuyCart) return;

            const progressBarMsg = rebuyCart.querySelector('#rebuy-cart__progress-bar-meter-label')
            if(!progressBarMsg) return;

            let newMsg = rebuyCart.querySelector('#heavy-item-message');

            if(hasHeavyItem) {
                if(!newMsg) {
                    newMsg = document.createElement('span');
                    newMsg.id = 'heavy-item-message';
                    Object.assign(newMsg.style, {
                        textAlign: 'center',
                        fontSize: '14px'
                    });
                    newMsg.textContent = `Free shipping not available for heavy items!`;
                    progressBarMsg.after(newMsg);
                }
                progressBarMsg.style.display = 'none';
                newMsg.style.display = 'block';
            } else {
                progressBarMsg.style.display = 'block';
                if(newMsg) {
                    newMsg.style.display = 'none';
                }
            }
        }
    }
    new HasHeavyItemsInCartManager()
})();

(function handleAccountNav() {
    function init() {
        const logout = document.querySelector('.customer_account_logout a');
        const login = document.querySelector('.customer_account_login a');
        const ca = window.__ca;
        if (!ca) return;

        if (logout) {
            logout.addEventListener('click', function (e) {
                e.preventDefault();
                window.location.href = ca.a;
            });
        }
        if (login) {
            login.addEventListener('click', function (e) {
                e.preventDefault();
                window.location.href = ca.b;
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

(function handleCartTrigger() {
    if (window.Theme.isB2B) return;

    let rebuyReady = typeof window.Rebuy !== 'undefined';
    document.addEventListener('rebuy:cart.ready', function() {
        rebuyReady = true;
    });

    window.addEventListener('load', function() {
        if (Shopify?.theme?.jsAjaxCart) {
            Shopify.theme.jsAjaxCart.showDrawer = function() {
                if (!rebuyReady) window.location.href = '/cart';
            };
        }
    });
})();
